import type { TKycResult, TKycStatus } from '#shared/types/account.types';

export const EUserCurrency = {
  Dollars: 'MMC',
  PlayMoney: 'MQC',
} as const;
export type TUserCurrency = (typeof EUserCurrency)[keyof typeof EUserCurrency];

export const EBankId = {
  Dollars: 6274,
  PlayMoney: 6275,
} as const;
export type TBankId = (typeof EBankId)[keyof typeof EBankId];

export const ESignUpSteps = {
  Credentials: 1,
  EmailConfirmation: 2,
  // PersonalData: 2,
  // Congrats: 3,
  DisplayNamePrompt: 3,
} as const;
export type TSignUpSteps = (typeof ESignUpSteps)[keyof typeof ESignUpSteps];

export interface IProfileData {
  id: string;
  displayName: string;
  firstName: string | null;
  lastName: string | null;
  state: string | { name: string };
  address: string | null;
  dateofbirth: string;
  email: string;
  checkAds: boolean;
  check18: boolean;
  group: string;
  level: number;
  country: string;
  accountStatus: string;
  bio: string;
  kycStatus: string;
  kycResult: string;
  emailVerified: boolean;
  emailVerifiedDate: string | null;
  verificationLinkCreatedAt: string | null;
  verificationLink: string | null;
  phoneNumber: {
    phoneNumber: string | null;
    verified: boolean;
  };
  phoneVerified: boolean;
  isTest: boolean;
  isATS: boolean;
  lastLogin: string | null;
  lastDailyBonus: string | null;
  welcomeEmailSent: boolean;
  verifyPhoneEmailSent: boolean;
  receiveEmails: boolean;
  receiveSms: boolean;
  disabled: boolean;
  disableMetadata: string | null;
  suspended: boolean;
  suspendMetadata: string | null;
  gameserverRegistrations: string[];
  createdAt: string;
  updatedAt: string;
  sessions: {
    id: number;
    active: boolean;
    sessionId: string;
    createdAt: string;
    updatedAt: string;
  }[];
  status:
    | 'closed'
    | {
        id: number;
        isOnline: boolean;
        isPlaying: boolean;
        updatedAt: string;
      };
  kyc: {
    result: TKycResult;
    status: TKycStatus;
    type?: string;
  };
  firstname: string | null;
  lastname: string | null;
}

export interface ICreateUserData {
  displayName?: string;
  email: string;
  checkAds: boolean;
  check18: boolean;
  password?: string;
  viaProvider?: boolean;
  agreeTerms?: boolean;
  googleToken?: string;
  affiliateCode?: string;
  partnerId?: string;
  source?: string;
}

export interface IBalanceData {
  deposit: number;
  pm: number;
  withdrawable: number;
}
